import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "5705887f-cb96-4765-8239-57fa17f8a5d0",
    authority: "https://login.microsoftonline.com/12a3af23-a769-4654-847f-958f3d479f4a",
    redirectUri: window.location.href,

  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      }
    }
  }
};
console.log("MSAL redirectUri is:", msalConfig.auth.redirectUri);


export const loginRequest = {
  scopes: ["User.Read"],
  popupWindowAttributes: "width=600,height=600,left=100,top=100" // Ensures popup window
};

export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();